"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSuperContext = void 0;
var react_1 = require("react");
function createSuperContext(factory, options) {
    if (options === void 0) { options = {}; }
    var defaultValue = {};
    var context = react_1.createContext(defaultValue);
    var useSuperContext = function () {
        var _a, _b, _c;
        var value = react_1.useContext(context);
        if (value === defaultValue) {
            if ((_a = options.testEnvironment) !== null && _a !== void 0 ? _a : ((_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) === "test") {
                return (_c = options.testValue) !== null && _c !== void 0 ? _c : defaultValue;
            }
            var forName = (options === null || options === void 0 ? void 0 : options.displayName) ? "(for " + options.displayName + ") " : "";
            throw new Error("Super context hook " + forName + "was called, but the context was not provided. Make sure to include the context in a SuperContext.");
        }
        return value;
    };
    return [function (props) { return ({ context: context, factory: factory, props: props, options: options }); }, useSuperContext];
}
exports.createSuperContext = createSuperContext;
